import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/ad756da4025d31f1ae7a1f7a866a3119/3d98b04b0600f3ac5caaf149bd10d081" 
              alt="PM Resources srl" 
              className="h-16 w-auto object-contain drop-shadow-md"
            />
          </div>

          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('servizi')}
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Servizi
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('chi-siamo')}
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Chi Siamo
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('soluzioni')}
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Soluzioni HR
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('lavora-con-noi')}
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Lavora con Noi
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('contatti')}
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contatti
            </button>
          </div>

          <button 
            onClick={() => scrollToSection('contatti')}
            className="px-6 py-3 text-white text-sm font-medium rounded-full hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{background:'#1E3A5F'}}
          >
            Richiedi Consulenza
          </button>
        </div>
      </div>
    </nav>
  );
}